var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.8,
    height: 14,
    viewBox: "0 0 16.8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M16.8 2.1L14.7 0 4.9 9.7 2.1 6.9 0 9.1 4.9 14l2.2-2.1z"
  })));
}
export default __webpack_public_path__ + "checkmark.1b018611.svg";
export { SvgCheckmark as ReactComponent };